<script lang="ts" setup>
export interface ItemProps {
  label: string
  value: string
  description?: string
}

defineProps<{
  title?: string
  items: ItemProps[]
}>()
</script>

<template>
  <SidebarSection>
    <h2 v-if="title" v-animate="{ animation: 'vertical-reveal' }" class="title">
      {{ title }}
    </h2>
    <ul class="cul">
      <li v-for="(item, index) in items" :key="index" v-animate="{ animation: 'vertical-reveal' }" class="item">
        <div class="info">
          <h3 class="label">{{ item.label }}</h3>
          <div v-if="item.description" class="text-xsmall" v-html="item.description" />
        </div>
        <div class="text-xsmall" v-html="item.value" />
      </li>
    </ul>
  </SidebarSection>
</template>

<style lang="scss" scoped>
.title {
  margin-bottom: 30px;

  @include f-21;
}

.item {
  display: grid;
  border-bottom: 1px solid var(--c-line-light);

  grid-template-columns: 1fr 2fr;
  gap: 10px;

  padding-block: 20px;

  &:first-child {
    padding-top: 0;
  }

  .info {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .label {
    margin-top: 5px;
  }

  .value {
    color: var(--c-text-medium);
  }

  h3,
  p {
    margin: 0;
  }

  :deep(p:last-child) {
    margin-bottom: 0;
  }
}
</style>
